// ----------------------------------------------------------------------

export const JWT_STORAGE_KEY = 'colinai_jwt_access_token';
export const USER_STORAGE_KEY = 'colinai_user_data';
